import GridLineIcon from 'remixicon-react/GridLineIcon'
import FunctionLineIcon from 'remixicon-react/FunctionLineIcon'
import {RemixiconReactIconComponentType} from 'remixicon-react'

import {RadixToggleGroup} from '@festi/common/components/form'

type ListType = 'normal' | 'small' | 'list'

interface ItemProp {
  icon: RemixiconReactIconComponentType
  value: ListType
}

interface Props {
  selected: string
  handleChange: (value: ListType) => void
}

export default function SearchGridToggleGroup({selected, handleChange}: Props) {
  const items: ItemProp[] = [
    {icon: FunctionLineIcon, value: 'normal'},
    {icon: GridLineIcon, value: 'small'},
    // {icon: ListCheckIcon, value: 'list'}, // NOTE: Disabled in phase 1
  ]

  return (
    <RadixToggleGroup
      items={items}
      selected={selected}
      handleChange={handleChange}
    />
  )
}
